"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var item = 'accept_cookies';

var get = function get() {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(item);
};

var set = function set(value) {
  if (typeof window === 'undefined') return;
  localStorage.setItem(item, value);
};

var _default = {
  get: get,
  set: set
};
exports["default"] = _default;